const eventType = 'click';

export { eventType };



// WEBPACK FOOTER //
// ./mobile-core/src/config/settings.js